export const url = {
    home: () => '/',

    catalog: () => '/shop/catalog',

    catalogUrl: (category) => `/shop/category/${category}`,

    category: (category) => `/shop/catalog/${category}`,

    product: (product) => `/shop/products/${product.slug}`,
};

export function getCategoryParents(category) {
    return category.parent ? [...getCategoryParents(category.parent), category.parent] : [];
}
